export const v1mixin = {
    data() {
        return {
            // 表头数据
            column: [
                {
                    label: "app",
                    prop: "app_title",
                },
                {
                    label: "app版本",
                    prop: "app_version",
                },
                {
                    prop: "system_title",
                    label: "系统",
                },
                {
                    prop: "uid",
                    label: "用户ID",
                },
                {
                    prop: "uuid",
                    label: "设备唯一标识",
                    width: 300,
                },
                {
                    prop: "origin",
                    label: "归因渠道",
                    width: 260,
                },
                {
                    prop: "channel",
                    label: "支付渠道",
                    width: 200,
                },
                {
                    prop: "aid",
                    label: "广告计划AID",
                    width: 200,
                },
                {
                    prop: "is_pay",
                    label: "支付情况",
                },
                {
                    prop: "pay_way",
                    label: "支付方式",
                    width: 120,
                },
                {
                    prop: "goods_title",
                    label: "商品名称",
                    width: 150,
                },
                {
                    prop: "order_cate",
                    label: "订单类型",
                },
                {
                    prop: "from_path",
                    label: "购买路径",
                    width: 180,
                },
                {
                    prop: "is_first",
                    label: "是否首单",
                },
                {
                    prop: "ostr",
                    label: "订单号",
                    width: 280,
                },
                {
                    prop: "transcation_no",
                    label: "交易号",
                    width: 280,
                },
                {
                    prop: "create_date",
                    label: "订单创建时间",
                    sortable: "custom",
                    width: 160,
                },
                {
                    prop: "pay_time",
                    label: "支付时间",
                    sortable: "custom",
                    width: 160,
                },
                {
                    label: "激活日期",
                    prop: "activate_time",
                    sortable: "custom",
                    width: 160,
                },
                {
                    prop: "pay_fee",
                    label: "支付金额",
                    sortable: "custom",
                },
            ],
            // 系统分类
            systemIds: [
                {
                    id: "1",
                    title: "Android",
                },
                {
                    id: "2",
                    title: "ios",
                },
                {
                    id: "3",
                    title: "小程序",
                },
            ],
            // 支付状态
            is_payIds: [
                {
                    id: "1",
                    title: "已支付",
                },
                {
                    id: "0",
                    title: "未支付",
                },
            ],
            //   支付方式
            pay_wayIds: [
                {
                    id: "3",
                    title: "Apple Pay",
                },
                {
                    id: "2",
                    title: "支付宝",
                },
                {
                    id: "1",
                    title: "微信",
                },
                {
                    id: "4",
                    title: "QQ支付",
                },
                {
                    id: "5",
                    title: "卡密支付",
                },
            ],
            //   订单分类
            order_cateIds: [
                {
                    id: "",
                    title: "全选",
                },
                {
                    id: "1",
                    title: "普通订单",
                },
                {
                    id: "2",
                    title: "订阅订单",
                },
                {
                    id: "3",
                    title: "其他",
                },
            ],
            //   是否首单
            is_firstIds: [
                {
                    id: "1",
                    title: "是",
                },
                {
                    id: "0",
                    title: "否",
                },
            ],
            //
            frontDashBoardData: [
                {
                    value: "0",
                    title: "订单金额",
                },
                {
                    value: "0",
                    title: "订单量",
                },
                {
                    value: "0",
                    title: "下单人数",
                },
                {
                    value: "0",
                    title: "客单价",
                },
            ],
        }
    }
}